import React from 'react'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { InfoItem } from 'Pages/Merchants/components'
import { SupplierOrderData } from 'Store/supplier-order/types'
import { RootState } from 'Store'
import { selectDatas } from 'Store/config/selector'
import { connect } from 'react-redux'

type Props = {
  detail?: SupplierOrderData
} & ReduxProps

const ClientInfo: React.FunctionComponent<Props> = props => {
  const { detail, configs } = props
  const priceLabel = configs?.value.price_labels || []

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const getConfigName = (key: string): string => {
    const result = priceLabel && priceLabel.find(item => item.name === key)
    return `${result?.value || ''} ${result?.description ? '(' + result?.description + ')' : ''}`
  }

  return (
    <BoxWrapper>
      <Row>
        <Col md={12} xs={24}>
          <BoxTitle>ข้อมูลลูกค้า</BoxTitle>
          {renderInfo('ชื่อ', detail?.customer?.name)}
          {renderInfo('ที่อยู่', detail?.customer?.address)}
          {renderInfo('เบอร์โทรศัพท์', detail?.customer?.mobile)}
          {renderInfo('อีเมล', detail?.customer?.email)}
          {renderInfo('ประเภทลูกค้า', getConfigName(detail?.customer?.type || ''))}
        </Col>
        {detail?.customer?.is_tax && (
          <Col md={12} xs={24}>
            <BoxTitle>ข้อมูลสำหรับออกใบกำกับภาษีรูปแบบเต็ม</BoxTitle>
            {renderInfo('ชื่อ', detail?.customer?.tax_name)}
            {renderInfo('เลขประจำตัวผู้เสียภาษี', detail?.customer?.tax_number)}
            {renderInfo('ที่อยู่', detail?.customer?.tax_address)}
            {renderInfo('เบอร์โทรศัพท์', detail?.customer?.tax_mobile)}
          </Col>
        )}
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const mapStateToProps = (state: RootState) => {
  return {
    configs: selectDatas(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ClientInfo)
